import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <>
     <Helmet>
    <title>Privacy Policy – Vedonica International</title>

    <meta
      name="description"
      content="Read Vedonica International's Privacy Policy to understand how we collect, use, and protect your personal information."
    />
  </Helmet>

    <div className="privacy-page">
      <div className="privacy-container">
        <div className="privacy-header">
          <span className="badge">Privacy & Security</span>
          <h1>Vedonica International Privacy Policy</h1>
          <p>
            Effective Date: April 2025 <br />
            Your trust matters to us. At Vedonica, we are committed to protecting
            your personal information and ensuring a secure shopping experience.
          </p>
        </div>

        <div className="privacy-grid">

          <div className="privacy-card">
            <h2>1. Information We Collect</h2>
            <p>
              We may collect your name, email, phone number, billing/shipping
              address, order history, and account details when you use our
              website or place an order.
            </p>
          </div>

          <div className="privacy-card">
            <h2>2. How We Use Your Data</h2>
            <p>
              We use your information for order processing, account management,
              customer support, returns, and improving your shopping experience.
            </p>
          </div>

          <div className="privacy-card">
            <h2>3. Cookies & Tracking</h2>
            <p>
              Cookies help us save your cart, remember preferences, improve
              website performance, and personalize your browsing experience.
            </p>
          </div>

          <div className="privacy-card">
            <h2>4. Payment Security</h2>
            <p>
              Vedonica never stores your card details. All transactions are
              securely handled through trusted payment gateways.
            </p>
          </div>

          <div className="privacy-card">
            <h2>5. Data Protection</h2>
            <p>
              We apply modern security measures to prevent unauthorized access,
              misuse, or disclosure of your personal information.
            </p>
          </div>

          <div className="privacy-card">
            <h2>6. Third-Party Sharing</h2>
            <p>
              We never sell your personal data. Information may only be shared
              with logistics, payment, or legal partners when necessary.
            </p>
          </div>

          <div className="privacy-card">
            <h2>7. Your Rights</h2>
            <p>
              You may request access, correction, deletion, portability, or
              withdrawal of consent regarding your personal data.
            </p>
          </div>

          <div className="privacy-card">
            <h2>8. Contact Us</h2>
            <p>
              Need help regarding privacy matters? Reach out to our support team.
              <br />
              Support Hours: Monday – Saturday, 10:00 AM – 6:00 PM IST
            </p>
          </div>

        </div>

        <div className="privacy-footer">
          <button className="home-btn" onClick={() => navigate("/")}>
            Back to Home
          </button>
        </div>
      </div>
    </div>
    </>
  );
}

export default PrivacyPolicy;